import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import DownloadButtonApple from "../images/mobile-store-button/apple.svg";
import DownloadButtonAppleSimplified from "../images/mobile-store-button/apple-simplified.svg";
import DownloadButtonGoogle from "../images/mobile-store-button/google.svg";
import DownloadButtonGoogleSimplified from "../images/mobile-store-button/google-simplified.svg";

import { useSiteMetadata } from "../hooks/useSiteMetadata";

const downloadButtons = {
    apple: {
        full: DownloadButtonApple,
        simplified: DownloadButtonAppleSimplified,
    },
    google: {
        full: DownloadButtonGoogle,
        simplified: DownloadButtonGoogleSimplified,
    },
};

const MobileStoreButton = ({ brand, simplified = false, className }) => {
    const DownloadButton =
        downloadButtons[brand][simplified ? "simplified" : "full"];
    const { appDownloadLinkApple, appDownloadLinkGoogle } = useSiteMetadata();
    const linkTargets = {
        apple: appDownloadLinkApple,
        google: appDownloadLinkGoogle,
    };
    const linkTarget = linkTargets[brand];

    return (
        <a
            href={linkTarget}
            aria-label="mobile-store-button"
            className={classNames(
                "mobile-store-button",
                `mobile-store-button-${brand}`,
                "d-inline-block",
                className
            )}
            rel="noreferrer"
        >
            <DownloadButton />
        </a>
    );
};

MobileStoreButton.propTypes = {
    brand: PropTypes.string.isRequired,
    simplified: PropTypes.bool,
};

export default MobileStoreButton;
